import {createRoot} from 'react-dom/client'

import App from './App'
import initializeSentry from './lib/sentry'

initializeSentry()

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
    // <StrictMode>
    <App />,
    // </StrictMode>,
)
